import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, ChevronDown } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { navigationMenu } from '../data/serviceData';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileOpenDropdown, setMobileOpenDropdown] = useState(null);
  const dropdownTimeoutRef = useRef(null);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
    setMobileOpenDropdown(null);
  }, [location.pathname]);

  // Desktop dropdown handlers
  const handleMouseEnter = (label) => {
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
    }
    setOpenDropdown(label);
  };

  const handleMouseLeave = () => {
    dropdownTimeoutRef.current = setTimeout(() => {
      setOpenDropdown(null);
    }, 150);
  };

  // Mobile dropdown toggle
  const toggleMobileDropdown = (label) => {
    setMobileOpenDropdown(mobileOpenDropdown === label ? null : label);
  };

  return (
    <header className="network-header">
      <div className="nav-wrapper">
        <Link to="/" className="network-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_arborist-services/artifacts/gqzllqd8_Paysfor%20tout%20seul.png" 
            alt="Paysfor" 
            style={{ height: '50px', width: 'auto' }}
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="network-nav desktop-nav">
          {navigationMenu.map((item) => (
            <div 
              key={item.path}
              className="nav-item-wrapper"
              onMouseEnter={() => item.hasDropdown && handleMouseEnter(item.label)}
              onMouseLeave={handleMouseLeave}
            >
              <Link
                to={item.path}
                className={`network-nav-link ${isActive(item.path) ? 'active' : ''} ${item.hasDropdown ? 'has-dropdown' : ''}`}
              >
                {item.label}
                {item.hasDropdown && <ChevronDown size={16} className={`dropdown-chevron ${openDropdown === item.label ? 'open' : ''}`} />}
              </Link>
              
              {/* Dropdown Menu */}
              {item.hasDropdown && openDropdown === item.label && (
                <div className="dropdown-menu">
                  {item.dropdownItems.map((subItem) => (
                    <Link
                      key={subItem.path}
                      to={subItem.path}
                      className="dropdown-item"
                    >
                      {subItem.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
          
          <Link 
            to="/contact" 
            className="btn-primary btn-nav-soumission"
          >
            Soumission
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="mobile-nav">
          {navigationMenu.map((item) => (
            <div key={item.path} className="mobile-nav-item">
              {item.hasDropdown ? (
                <>
                  <div className="mobile-nav-link-wrapper">
                    <Link
                      to={item.path}
                      className={`mobile-nav-link ${isActive(item.path) ? 'active' : ''}`}
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {item.label}
                    </Link>
                    <button 
                      className="mobile-dropdown-toggle"
                      onClick={() => toggleMobileDropdown(item.label)}
                      aria-label={`Ouvrir le sous-menu ${item.label}`}
                    >
                      <ChevronDown size={20} className={mobileOpenDropdown === item.label ? 'open' : ''} />
                    </button>
                  </div>
                  
                  {/* Mobile Dropdown */}
                  {mobileOpenDropdown === item.label && (
                    <div className="mobile-dropdown">
                      {item.dropdownItems.map((subItem) => (
                        <Link
                          key={subItem.path}
                          to={subItem.path}
                          className="mobile-dropdown-item"
                          onClick={() => setMobileMenuOpen(false)}
                        >
                          {subItem.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <Link
                  to={item.path}
                  className={`mobile-nav-link ${isActive(item.path) ? 'active' : ''}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              )}
            </div>
          ))}
          
          <Link 
            to="/contact" 
            className="btn-primary mobile-soumission-btn"
            onClick={() => setMobileMenuOpen(false)}
          >
            Soumission
          </Link>
          
          <a 
            href={`tel:${companyInfo.phone}`} 
            className="btn-secondary mobile-phone-btn"
            onClick={() => setMobileMenuOpen(false)}
          >
            <Phone size={18} style={{ marginRight: '8px' }} />
            {companyInfo.phone}
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
